import { useEffect, useState } from 'react';

import { Fade } from '@chakra-ui/react';

import { useLazyCheckSpinQuery, useLazyGetParticipantBoostersQuery } from 'api/contest';

import Boosters from 'components/booster/Boosters';

import Spinner from './BuilderPage/ui/Spinner/Spinner';

type LeagueFilter = 'all' | 'nba' | 'nfl' | 'mlb' | 'wnba';

const AllBoostersPage = () => {
  const [isSpinOpen, setIsSpinOpen] = useState<boolean | null>(null);

  const [fetchBoosters, { data: boosters, isLoading, isFetching }] = useLazyGetParticipantBoostersQuery();
  const [checkSpin, { data: dailySpinStatus, isLoading: dailySpinStatusLoading }] = useLazyCheckSpinQuery();

  useEffect(() => {
    if (isSpinOpen === null) {
      if (dailySpinStatus) {
        setIsSpinOpen(dailySpinStatus.canSpinToday);
      } else {
        checkSpin();
      }
    }
  }, [dailySpinStatus]);

  useEffect(() => {
    fetchBoosters({});
  }, [fetchBoosters]);

  const handleLeagueChange = (league: LeagueFilter) => {
    fetchBoosters({ league });
  };

  const onCloseHandler = () => {
    setIsSpinOpen(false);
    checkSpin();
  };

  return (
    <>
      {!dailySpinStatusLoading && (
        <Fade in={true}>
          {isSpinOpen && <Spinner onClose={onCloseHandler} dailySpinStatus={dailySpinStatus} />}

          {!isSpinOpen && (
            <Boosters
              isLoading={isLoading || isFetching}
              boosters={boosters}
              onLeagueChange={handleLeagueChange}
              title="Boosts"
              subTitle="Earn coins on top of PTS"
            />
          )}
        </Fade>
      )}
    </>
  );
};

export default AllBoostersPage;
